import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {getDataTypeName, shouldShowValues} from '../../../utils/issueAttributes-helpers';
import isNullOrUndefined from '@adsk/bim360-matrix-react-helpers/es/isNullOrUndefined';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';

class IssueAttributesAdminAttributeLine extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false
    };

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }
  onMouseEnter() {
    this.setState({isHovered: true});
  }

  onMouseLeave() {
    this.setState({isHovered: false});
  }

  prepareOptionsString() {
    const {issueAttribute} = this.props;
    const {metadata, dataType} = issueAttribute;
    return `(${metadata[dataType].options.map(option => option.value).join(', ')})`;
  }

  render() {
    const {issueAttribute, container} = this.props;
    const {description, dataType, title} = issueAttribute;
    const options = shouldShowValues(issueAttribute) ? this.prepareOptionsString() : '';
    const showPopover = this.state.isHovered && !isNullOrUndefined(description);

    return (
      <div className="IssueAttributesAdminAttributeLine" data-testid="IssueAttributesAdminAttributeLine">
        <div
          className="IssueAttributesAdminAttributeLine__title"
          data-testid="IssueAttributesAdminAttributeLine__title"
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        >
          <Tooltip
            tooltipClassName="IssueAttributesAdminAttributeLine__popover"
            content={description}
            show={showPopover}
            container={container}
          >
            {title}
          </Tooltip>
        </div>
        <div
          className="IssueAttributesAdminAttributeLine__description"
          data-testid="IssueAttributesAdminAttributeLine__description"
        >
          {`${getDataTypeName(dataType)} ${options}`}
        </div>
      </div>
    );
  }
}

IssueAttributesAdminAttributeLine.displayName = 'IssueAttributesAdminAttributeLine';

IssueAttributesAdminAttributeLine.propTypes = {
  container: PropTypes.object.isRequired,
  issueAttribute: PropTypes.object.isRequired
};

export default IssueAttributesAdminAttributeLine;
